import { Blog } from "@/features/Blog";
import { MainLayout } from "@/layouts/MainLayout";

const BlogPage: Page = () => <Blog />;

BlogPage.getLayout = (page) => <MainLayout>{page}</MainLayout>;

export default BlogPage;
